import { render, staticRenderFns } from "./ResetAppUserLog.vue?vue&type=template&id=1793c97a&lang=pug&"
import script from "./ResetAppUserLog.vue?vue&type=script&lang=ts&"
export * from "./ResetAppUserLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports